import { render, staticRenderFns } from "./PidPendingNearMatchRow.vue?vue&type=template&id=082d838d&scoped=true&"
import script from "./PidPendingNearMatchRow.vue?vue&type=script&lang=js&"
export * from "./PidPendingNearMatchRow.vue?vue&type=script&lang=js&"
import style0 from "./PidPendingNearMatchRow.vue?vue&type=style&index=0&id=082d838d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082d838d",
  null
  
)

export default component.exports